"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var link_1 = __importDefault(require("next/link"));
var react_1 = __importDefault(require("react"));
var LoginGiftcodeBonus_1 = __importDefault(require("../../common/LoginGiftcodeBonus"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var LogInBonus = function () {
    var t = (0, next_intl_1.useTranslations)('translation');
    var breakpoint = (0, apps_shared_1.useBreakpoint)();
    var signUpUrl = (0, apps_shared_1.useModalLink)(apps_shared_1.POPUP_CONSTANTS.SIGN_UP_MODAL, true);
    var openSignIn = (0, apps_shared_1.useOpenSignIn)();
    return (react_1.default.createElement(ui_components_1.Modal, { width: "480px", padding: Object.keys(breakpoint).length > 0 && breakpoint.mobile
            ? '4px 16px'
            : '20px 40px', className: styles_module_scss_1.default.modalSignIn, saveSize: true },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.logo },
            react_1.default.createElement("img", { src: "/img/logo.svg", alt: "logo" })),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
            react_1.default.createElement(LoginGiftcodeBonus_1.default, { withText: true }),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
                    react_1.default.createElement(ui_components_1.FixedButton, { type: "submit", text: "upper", width: "100%", maxWidth: "100%", onClick: openSignIn }, t('login'))),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.centerLinkWrapper },
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.noAccount },
                        t('noAccount'),
                        ' ',
                        react_1.default.createElement(link_1.default, { className: styles_module_scss_1.default.signUp, href: signUpUrl }, t('signup'))))))));
};
exports.default = LogInBonus;
